export default "__VITE_ASSET__BxIz9C86__"